export enum UnitView {
  ENERGY = 'ENERGY', // kWh/kW
  COST = 'COST', // EUR
}
export enum PortfolioView {
  TOTAL_PORTFOLIO = 'TOTAL_PORTFOLIO', // portfolio gesamt
  CURRENT_FIXES = 'CURRENT_FIXES', // aktuelle fixierungen
}

type CurveMetadata = {
  unit: 'kW' | 'kWh' | 'EUR' | 'CENT' // TODO - wibi: put more generic type
}

/**
 * To partition a bar section: below and above the consumption line.
 *
 * below: Partition below the consumption line. It should render the color of the section itself (spotBought: solid purple)
 *
 * above: Partition above the consumption line. It should render the color transparently (spotBought: opaque purple)
 */
export type DataPointPartition = {
  below: number | null
  above: number | null
}

export type TotalPortfolioDataPoint = {
  timestampStart: Date
  timestamp: string
  tranches: number | null
  pacs: number | null
  ppas: number | null
  total: number | null
  actualConsumption: number | null
  plannedConsumption: number | null
  spotBought: number | null
  spotSold: number | null
  negatedSpotSold: number | null
  prices: {
    tranches?: number | null
    pacs?: number | null
    ppas?: number | null
    spotBought?: number | null
    spotSold?: number | null
    total?: number | null
  }
  partition: {
    tranches: DataPointPartition
    pacs: DataPointPartition
    ppas: DataPointPartition
    spotBought: DataPointPartition
  }
  isPast: boolean
}

export type TotalPortfolioCurve = CurveMetadata & {
  dataPoints: TotalPortfolioDataPoint[]
}

export type CurrentFixesDataPoint = {
  timestampStart: Date
  timestamp: string
  tranches: number | null
  pacs: number | null
  ppas: number | null
  planned: number | null
  spotBought: number | null
  spotSold: number | null
  negatedSpotSold: number | null
  total: number | null
  actualConsumption: number | null
  plannedConsumption: number | null
  partition: {
    tranches: DataPointPartition
    pacs: DataPointPartition
    ppas: DataPointPartition
    planned: DataPointPartition
  }
  prices: {
    tranches?: number | null
    pacs?: number | null
    ppas?: number | null
    spotBought?: number | null
    spotSold?: number | null
    planned?: number | null
    total?: number | null
  }
  isPast: boolean
}

export type CurrentFixesCurve = CurveMetadata & {
  dataPoints: CurrentFixesDataPoint[]
}

export type PortfolioDataPoints = TotalPortfolioDataPoint[] | CurrentFixesDataPoint[]

export type PortfolioDataPoint = TotalPortfolioDataPoint | CurrentFixesDataPoint

export type PortfolioDataPointWithTimestamp = PortfolioDataPoint & { timestamp: string }
